import Updates from "./components/Updates";
import AchievementFile from "./components/AchievementFile";
import ResearchesCenter from "./components/ResearchesCenter";
// import Procedures from "./components/Procedures";
import ExaminersSection from "./components/ExaminersSection";
import BankingInformation from "./components/BankingInformation";
import { ActivePages, SectionsIds, UserTypes, sections } from "../../orderPage.types";
import { CourseLocalItemResult } from "services/courseService/models/CourseType";
import { CourseOrderLocalItemResult } from "services/courseOrder/models/CourseOrderType";
import {Dispatch, SetStateAction, useEffect, useState} from "react";
import ApplicantInfo from "./components/ApplicantInfo";
import Rewards from "./components/Rewards";
import PublishingHouse from "./components/PublishingHouse";
import Procedures from "./components/Procedures";
import Judges from "./components/Judges";
import ScientificPublication from "./components/ScientificPublication";
import ScientificPublicationLibraries from "./components/ScientificPublicationLibraries";
import OrderDetails from "./components/OrderDetails";
import AssignPermission from "./components/AssignPermission";
import CenterManagerSelect from "./components/CenterManagerSelect";
import OrderForm from "../../../OrderForm";
import UpdateAuthorFrom from "./components/AuthorOrderForm";
import {NotesType, WorkflowNotes} from "./components/WorkFlowNotes";
import RefereesSection from "./components/RefereesSection";
import RefereeCenter from "./components/RefereeCenter";
import {ISBNSection} from "./components/ISBNSections";
import {ISBNFromSection} from "./components/ISBNSections/ISBNFromSection";
import EditRewards from "./components/Rewards/EditRewards";
import {ExaminerReward} from "./components/Rewards/ExaminerReward";
import {RefereeReward} from "./components/Rewards/RefereeReward";
import ExaminerRecommendations from "./components/examinerRecommendations";
import Index from "./components/refereeRecommendations";
import {getUserSession} from "../../../../../../helpers/UserInfo";
import ExaminerIterationSections from "./components/ExaminerIterationSections";
import RefereeIterationSections from "./components/RefereeIterationSections";
import { ScientificPublicationForm } from "./components/ScientificPublicationForm";


export const OrderInfoTab = ({
  courseOrder,
  course,
  userType,
  activePage,
  setActivePage,
  openedTask,
  submitRef,
  activeSectionsIds,
  setTriggerOrderUpdate
}: {
  openedTask: any;
  courseOrder: CourseOrderLocalItemResult | null;
  course?: CourseLocalItemResult | null;
  userType: UserTypes;
  activePage: ActivePages;
  setActivePage: Dispatch<SetStateAction<ActivePages>>;
  setTriggerOrderUpdate: Dispatch<SetStateAction<boolean>>;
  activeSectionsIds: SectionsIds[];
  submitRef?: any;
}) => {
  return (
    <div className="position-relative">
      {activeSectionsIds.map((sectionId) => {
        switch (sectionId) {
          case sections.workflowNote:
            return <WorkflowNotes key={sectionId} order={courseOrder} />; 
          case sections.applicantInfoWithDetails:
            return <ApplicantInfo key={sectionId} course={course} order={courseOrder} userType={userType} />;
          case sections.orderDerails:
            return <OrderDetails key={sectionId} course={course} order={courseOrder} userType={userType} />;
          case sections.updates:
            return (
              <Updates
                key={sectionId}
                userType={userType}
                setActivePage={setActivePage}
                programOrderUpdateId={openedTask?.programOrderUpdateId ?? 0}
                order={courseOrder}
                programUpdateHandlersRef={submitRef}
              />
            );
          case sections.achievementFile:
            return (
              <AchievementFile
                key={sectionId}
                userType={userType}
                activePage={activePage}
                closeOrderFormProps={submitRef}
                order={courseOrder}
              />
            );
          case sections.rewards:
            return <Rewards key={sectionId} order={courseOrder} />;
          case sections.publishingHouse:
            return <PublishingHouse key={sectionId} />;
          case sections.researchesCenter:
            return <ResearchesCenter key={sectionId} order={courseOrder} />; 
            case sections.refereeCenter:
            return <RefereeCenter key={sectionId} order={courseOrder} />;
          case sections.procedures:
            return <Procedures key={sectionId} orderId={courseOrder?.id ?? 0}   />;
          case sections.judges:
            return <Judges key={sectionId} order={courseOrder} />;
          case sections.examinerSection:
            return <ExaminerIterationSections order={courseOrder} key={sectionId}  setTriggerOrderUpdate={setTriggerOrderUpdate}/>;

            //return <ExaminersSection order={courseOrder} key={sectionId} />;     
            case sections.refereeSection:
            return <RefereeIterationSections order={courseOrder} key={sectionId}  setTriggerOrderUpdate={setTriggerOrderUpdate}/>;
          case sections.userBankingInfo:
            return <BankingInformation key={sectionId} closeOrderFormProps={submitRef} />; // to be changed
          case sections.scientificPublication:
            return <ScientificPublication key={sectionId} courseOrder={courseOrder} />;
          case sections.scientificPublicationLibraries:
            return <ScientificPublicationLibraries key={sectionId} courseOrder={courseOrder} />;
          case sections.examinerRewards:
            return <ExaminerReward key={sectionId} />; 
            case sections.refereeRewards:
            return <RefereeReward key={sectionId} />;
            case sections.assignPermission:
            return <AssignPermission key={sectionId} />;
          case sections.ISBNSection:
            return <ISBNSection key={sectionId}  order={courseOrder} />;
          case sections.ISBNFromSection:
            return <ISBNFromSection key={sectionId}  order={courseOrder} submitRef={submitRef} />;
          case sections.rewardsEdit:
            return <EditRewards key={sectionId} order={courseOrder} submitRef={submitRef} course={course} />;
          case sections.CenterManagerSelect:
            return <CenterManagerSelect key={sectionId} order={courseOrder}  submitRef={submitRef}  />;
          case  sections.examinerRecommendations:
            return <ExaminerRecommendations key={sectionId} order={courseOrder}  />;  
            case  sections.refereeRecommendations:
            return <Index key={sectionId} order={courseOrder}  />;
            case sections.updateOrder:
              return <UpdateAuthorFrom key={sectionId} order={courseOrder} submitRef={submitRef}  />;
            case sections.fileUpdateOrder:
                return <UpdateAuthorFrom key={sectionId} order={courseOrder} submitRef={submitRef} isFile={true} />;
            case sections.fileOnlyUpdateOrder:
              return <UpdateAuthorFrom key={sectionId} order={courseOrder} submitRef={submitRef} isReadOny={true} />;
            case sections.scientificPublicationForm:
              return <ScientificPublicationForm key={sectionId} order={courseOrder} submitRef={submitRef} />;
          /* case sections.progressCertificate:
            return (
              <ProgressCertificate
                key={sectionId}
                approveByCenterManagerSubmitHandlerRef={approveByCenterManagerSubmitHandlerRef}
                closeOrder={order?.closeOrder}
                isForEdit={userType === OrderUserTypes.ResearchCenterManagerForCloseRequest}
              />
            ); */
          default:
            return null;
        }
      })}
    </div>
  );
};
